import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'container',
    (theme, [checked, disabled, excluded]) => [
      `
			font-size: 1rem;
			display: inline-block;
			border-width: 1px;
			border-style: ${
        theme.survey.option[checked ? 'active' : 'default'].border.style
      };
			background-color: ${
        theme.survey.option[checked ? 'active' : 'default'].background
      };
			width: 100%;
			padding: 3px;
			border-radius: 3px;
			box-sizing: border-box;
			overflow: hidden;
			position: relative;
			cursor: ${disabled ? 'not-allowed' : 'pointer'};
			margin: 0 0 10px 0;
			-webkit-tap-highlight-color: transparent;
			transition: background-color 0.2s;
		`,
      (disabled || excluded) &&
        `
			border-color: ${theme.color.text.B2};
		`,
      !(disabled || excluded) &&
        `
			border-color: ${theme.survey.option[checked ? 'active' : 'default'].border.color};
		`,
      !(disabled || excluded || checked) &&
        `
			&:hover {
				.Checkbox {
					color: ${theme.color.primary.default};
				}

				.Radio_border {
					border-color: ${theme.color.primary.default};
				}
			}
		`
    ]
  ],
  [
    'middle',
    `
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	`
  ],
  [
    'iconContainer',
    `
		position: relative;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		padding: 8px;
		text-align: center;
	`
  ],
  [
    'text',
    (theme, [checked, disabled, excluded]) => [
	  `		
			:lang(ar){
				transform: scaleX(-1);
				direction: rtl;
			}
			color: ${theme.survey.option[checked ? 'active' : 'default'].text};
			line-height: 1.5;
			font-size: 1.15em;
			font-weight: 400;
			transition: color 0.2s;
			margin: 0.15em 0 0 0;
			width: calc(100% - 32px);
			overflow-wrap: break-word;
		`,
      (disabled || (excluded && !checked)) &&
        `
			color: ${theme.color.text.B2};
		`
    ]
  ],
  [
    'disabledText',
	theme => `
		:lang(ar){
			transform: scaleX(-1);
			direction: rtl;
		}
		color: ${theme.color.semantic.error};
		line-height: 1.5;
		font-size: 0.9em;
		font-weight: 400;
	`
  ],
  [
    'childrenContainer',
    theme => `
		padding: 8px;
		border-radius: 3px;
		margin: 8px 0;
		background-color: white;
		border: 1px solid ${theme.color.primary.hover};
	`
  ]
]);
